export class InvoiceItem {
    public assignationId: string;

    public departureAt: Date;

    public title: string;

    public invoiceBaseAmount: number;

    public get baseInvoiceAmountDisplay(): string {
        return (this.invoiceBaseAmount / 100).toFixed(2);
    }

    public baseAmount: number;

    public get baseAmountDisplay(): string {
        return (this.baseAmount / 100).toFixed(2);
    }

    public invoiceVatAmount: number;

    public get invoiceVatAmountDisplay(): string {
        return (this.invoiceVatAmount / 100).toFixed(2);
    }

    public baseVatAmount: number;

    public vatAmount: number;

    public get vatAmountDisplay(): string {
        return (this.vatAmount / 100).toFixed(2);
    }

    public get invoiceAmountDisplay(): string {
        return ((this.invoiceBaseAmount + this.invoiceVatAmount) / 100).toFixed(2);
    }

    public vatPercentage: number;
}
